export const SECTION_EMPLOYMENT_VERIFICATION_LABEL = "Waiting on Section"

export const SECTION_EMPLOYMENT_VERIFICATION_MESSAGE =
  "Your application is waiting on your section to verify your employment."

export const REINSTATEMENT_SECTION_EMPLOYMENT_VERIFICATION_MESSAGE =
  "Your reinstatement application is waiting on your section to verify your employment."

// Membership Services has asked for changes, so that status stays in front of
// the section wait. Approved applications are past this step.
const REVIEW_STATUSES = new Set(["submitted", "under_review"])

export const showsSectionEmploymentVerification = (status, awaiting) =>
  awaiting === true && REVIEW_STATUSES.has(String(status || "").toLowerCase())
